import { lazy } from 'react';

export const Mailings = lazy(() => import('./ui/Mailings'));
